/**
 * Treats an input as form with a single element
 *
 * Return submits the form, escape reverts to the original text
 */

import React from 'react'

import { TextInput, TextInputProps } from '@mantine/core'

interface InlineTextFormProps extends Omit<TextInputProps, 'onSubmit'> {
  onSubmit(value: string): void
  onCancel?(): void
}

export const InlineTextForm = (props: InlineTextFormProps) => {
  const { onSubmit, onCancel, ...textInputProps } = props

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault()
    const formData = new FormData(event.currentTarget)
    const value = formData.get('value')
    if (value !== null && typeof value === 'string') onSubmit(value)
  }

  const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = (
    event,
  ) => {
    if (event.key === 'Escape' && onCancel) {
      event.preventDefault()
      onCancel()
    }
  }

  const handleBlur: React.FocusEventHandler<HTMLInputElement> = (event) => {
    onSubmit(event.target.value)
  }

  return (
    <form onSubmit={handleSubmit} style={{ flex: 1 }}>
      <TextInput
        name="value"
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        autoFocus
        {...textInputProps}
      />
    </form>
  )
}
